// ==========================================
// 1. src/components/common/Button.js
// ==========================================
import React from 'react';

export const Button = ({ href, variant = 'primary', children, className = '', ...props }) => {
  const baseClasses = 'inline-flex items-center justify-center px-8 py-4 rounded-lg font-semibold text-lg transition';
  
  const variants = {
    primary: 'bg-blue-600 text-white hover:bg-blue-700',
    secondary: 'bg-white text-gray-700 border border-gray-200 hover:bg-gray-50',
    outline: 'bg-transparent text-blue-600 border-2 border-blue-600 hover:bg-blue-600 hover:text-white'
  };

  const classes = `${baseClasses} ${variants[variant]} ${className}`;

  if (href) {
    return (
      <a href={href} className={classes} {...props}>
        {children}
      </a>
    );
  }

  return (
    <button className={classes} {...props}>
      {children}
    </button>
  );
};

export default Button;